<script>
export default {
  name: 'PaymentMethod',
  props: {
    credits: { type: Boolean, default: () => false },
    selected: { type: Boolean, default: () => false },
    data: {
      type: Object,
      required: true,
      icon: ''
    },
    checkout: {
      type: Boolean,
      required: false,
      icon: ''
    }
  },
  computed: {
    // Get card icon
    icon() {
      if (this.credits) return 'fas fa-wallet'

      let iconName = this.data.brand.toLowerCase()
      if (iconName === 'american express') {
        iconName = 'visa'
      }
      return `fab fa-cc-${iconName}`
    }
  },
  methods: {
    pad(n) {
      if (n) {
        return String(n).padStart(2, '0')
      }
      return n
    }
  }
}
</script>

<template>
  <div class="payment-method">
    <div :key="data.id" class="list-item">
      <!-- Card -->
      <div v-if="!credits" class="list-item-card-number body-2">
        <v-icon :class="`primary--text icon ${icon}`">{{ icon }}</v-icon>
        <div v-for="i in 4" :key="i" class="dot" />
        <div class="ml-1 black--text">{{ data.last4 }}</div>
      </div>

      <!-- credits -->
      <div v-else class="list-item-card-number body-2">
        <v-icon :class="`accent--text icon ${icon}`">
          {{ icon }}
        </v-icon>
        <span class="font-weight-medium black--text">Pona credits</span>
      </div>

      <div class="d-flex justify-end align-center secondary--text">
        <!-- Is method used by default -->
        <v-icon v-if="selected && !checkout" small>
          ✓
        </v-icon>

        <span v-if="credits" class="ml-2">
          {{ data.currencyCode || 'RM' }} {{ data.value | round(2) }}
        </span>
        <span v-else class="ml-2">
          {{ pad(data.expMonth) }} / {{ data.expYear }}
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="sass">
.payment-method
  width: 100%
  display: flex
  flex: 1
  .list-item
    display: inline-block
    width: 100%
    .list-item-card-number
      display: flex
      flex-direction: row
      align-items: center
      font-size: 15px
      float: left
      .icon
        margin-right: 14px
      .dot
        height: 3px
        width: 3px
        background: #2e3032
        border-radius: 100%
        margin-right: 4px
</style>
